import { render, staticRenderFns } from "./CompanyTenancyRecord.vue?vue&type=template&id=00a993d4&scoped=true&"
import script from "./CompanyTenancyRecord.vue?vue&type=script&lang=js&"
export * from "./CompanyTenancyRecord.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTenancyRecord.vue?vue&type=style&index=0&id=00a993d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a993d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a993d4')) {
      api.createRecord('00a993d4', component.options)
    } else {
      api.reload('00a993d4', component.options)
    }
    module.hot.accept("./CompanyTenancyRecord.vue?vue&type=template&id=00a993d4&scoped=true&", function () {
      api.rerender('00a993d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/CompanyTenancyRecord.vue"
export default component.exports